import { MobiDocument } from './MobiDocument';

export class Famille extends MobiDocument{
    private _id: string;
    private _rev: string;
    private id: number;
    private emailprincipal:string;
    private emailsecondaire:string;
    private telephonefamille:string;
    private portablefamille:string;

    public constructor(famille: any){
        super();
        this._id = famille._id;
        this._rev = famille._rev;
        this.id = famille.id;
        this.emailprincipal = famille.emailprincipal;
        this.emailsecondaire =famille.emailsecondaire;
        this.telephonefamille = famille.telephonefamille;
        this.portablefamille =  famille.portablefamille;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getEmailprincipal(): string {
        return this.emailprincipal;
    }

    public setEmailprincipal(emailprincipal: string): void {
        this.emailprincipal = emailprincipal;
    }

    public getEmailsecondaire(): string {
        return this.emailsecondaire;
    }

    public setEmailsecondaire(emailsecondaire: string): void {
        this.emailsecondaire = emailsecondaire;
    }

    public getTelephonefamille(): string {
        return this.telephonefamille;
    }

    public setTelephonefamille(telephonefamille: string): void {
        this.telephonefamille = telephonefamille;
    }

    public getPortablefamille(): string {
        return this.portablefamille;
    }

    public setPortablefamille(portablefamille: string): void {
        this.portablefamille = portablefamille;
    }
}